export default __webpack_public_path__ + "static/media/006-squid.0bb09ae4.svg";